/**
 * useTenant hook
 */

import { useContext } from 'react';

import { TenantContext, type TenantContextType } from '~/contexts/TenantContext.context';

/**
 * Access the TenantContext.
 * Must be used within a TenantProvider.
 *
 * @throws Error if used outside TenantProvider
 */
export const useTenant = (): TenantContextType => {
  const context = useContext(TenantContext);
  if (context === undefined) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
};
